import Resume from "./assets/images/Vaishnavi_Kulkarni_Resume.pdf";

export const ResumePDF = {
    resume: Resume,
}
